import React, { useRef } from 'react';
import { Stack, Typography } from '@mui/material';

import { ChaseLayoutFeatureArea } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

import { OptionallyNullableFieldWrapper } from '../../../../controls/OptionallyNullableFieldWrapper';

interface Props {
  value: Omit<ChaseLayoutFeatureArea, 'guid'>;
  disabled?: boolean;
  onChange: (value: Omit<ChaseLayoutFeatureArea, 'guid'>) => void;
}

export function ChaseFeatureAreaControls({ value, disabled, onChange }: Props) {
  const minWidthRef = useRef<HTMLInputElement>(null);
  const maxWidthRef = useRef<HTMLInputElement>(null);

  return (
    <Stack direction="column" spacing={1}>
      <Stack direction="row" spacing={2}>
        <OptionallyNullableFieldWrapper
          inputRef={minWidthRef}
          property="Minimum Width"
          disabled={disabled}
          value={value.minWidth}
          onMadeNull={() => {
            onChange({ ...value, minWidth: null });
          }}
        >
          <DistanceField
            inputRef={minWidthRef}
            label="Minimum Width"
            disabled={disabled}
            canBeNull
            value={value.minWidth}
            onSubmit={(minWidth) => {
              onChange({ ...value, minWidth });
            }}
          />
        </OptionallyNullableFieldWrapper>

        <OptionallyNullableFieldWrapper
          inputRef={maxWidthRef}
          property="Maximum Width"
          disabled={disabled}
          value={value.maxWidth}
          onMadeNull={() => {
            onChange({ ...value, maxWidth: null });
          }}
        >
          <DistanceField
            inputRef={maxWidthRef}
            label="Maximum Width"
            disabled={disabled}
            canBeNull
            value={value.maxWidth}
            onSubmit={(maxWidth) => {
              onChange({ ...value, maxWidth });
            }}
          />
        </OptionallyNullableFieldWrapper>
      </Stack>

      <Typography variant="subtitle2" color="textSecondary" sx={{ textWrap: 'wrap' }}>
        Both optional. Allows the chase to expand up to the maximum width or shrink down to the minimum width.
      </Typography>
    </Stack>
  );
}
